



























































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../common/user-avatar.vue";
import BillingAccount from "../../store/entities/billingAccount";
import RevokeOwner from "./revoke-owner.vue";
import ChangePrimaryOwner from "./change-primary-owner.vue";

export default Vue.extend({
  name: "SetupOwners",
  components: { UserAvatar, RevokeOwner, ChangePrimaryOwner },
  props: {
    showEditor: Boolean,
  },
  data() {
    return {
      memberToRevoke: null,
      showRevokeOwner: false,
      showChangePrimaryOwner: false,
      newPrimaryOwnerId: null,
      setupModel: {
        newOwnerId: null,
      },
      rules: {
        newOwnerId: [
          {
            required: true,
            type: "number",
            message: "Please select a member to be the owner",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("billing", ["loading", "billingAccount"]),
    showModal(): any {
      return this.showEditor;
    },
    generalMembers() {
      let context = this as any;
      return context.billingAccount.members.filter((m) => m.role != 1);
    },
    owners() {
      let context = this as any;
      let billingAccount = context.billingAccount as BillingAccount;
      let owners = billingAccount && billingAccount.members ? billingAccount.members.filter((m) => m.role === 1) : [];
      return owners.sort((a, b) => {
        return a.memberId != context.billingAccount.originalOwnerId && b.memberId != context.billingAccount.originalOwnerId ? 0 : a.memberId != context.billingAccount.originalOwnerId ? 1 : -1;
      });
    },
  },
  watch: {
    showModal(newVal) {
      let context = this as any;
      if (newVal === true) {
        context.setupModel.newOwnerId = null;
      }
    },
  },
  methods: {
    handleCancel() {
      (this.$refs.SetupForm as any).resetFields();
      this.$emit("cancel");
    },
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleRevoke(ownerId) {
      this.$store.dispatch("billing/removeAccountOwner", { data: { ownerId: ownerId } });
    },
    showChangePrimaryOwnerModal(newPrimaryOwnerId) {
      this.newPrimaryOwnerId = newPrimaryOwnerId;
      this.showChangePrimaryOwner = true;
    },
    makePrimary(eventData) {
      let context = this as any;

      this.$store
        .dispatch("billing/changeAccountOwner", { data: { newOwnerId: eventData.newPrimaryOwnerId, updateInvoiceEmail: eventData.updateInvoiceEmail } })
        .then(() => {
          context.$Modal.success({
            title: "Change Primary Owner",
            render: (h) => {
              return h("div", [
                h("span", "Success! "),
                h(
                  "a",
                  {
                    on: {
                      click: (val) => {
                        context.$Modal.remove();
                        context.$emit("update-card");
                      },
                    },
                  },
                  "Click here to update credit card"
                ),
              ]);
            },
          });
        })
        .finally(() => {
          this.showChangePrimaryOwner = false;
        });
    },
    grantOnwerPowers(event) {
      let context = this as any;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let selectedMember = this.generalMembers.filter((member) => member.memberId == this.setupModel.newOwnerId)[0];
          let data = {
            memberId: selectedMember.memberId,
            role: 1,
            email: selectedMember.memberEmailAddress,
            name: selectedMember.memberName,
            billingAccountId: context.billingAccount.id,
          };

          this.$store
            .dispatch("billing/updateMember", {
              data: data,
            })
            .then((response) => {
              context.$store.dispatch("billing/getBillingAccountInfo", {
                id: context.billingAccount.id,
              });
            })
            .finally(() => {
              target.disabled = false;
            });
        } else {
          target.disabled = false;
        }
      });
    },
    revokeOnwerPowers(selectedMember, event) {
      this.memberToRevoke = selectedMember;
      this.showRevokeOwner = true;
    },
  },
});
